import { css, RuleSet } from 'styled-components'
import { tok, tokPx } from '../../utils'

function outlineStyles(offset: number = 2) {
  return css`
    outline: ${tokPx('semantics_focus_outer_ring_width')} solid ${tok('semantics_focus_outer_ring_color')};
    outline-offset: ${offset}px;
  `
}

export function focusOutline(offset?: number): RuleSet<object> {
  return css`
  &:focus-visible {
    ${outlineStyles(offset ?? 2)};
  }
`
}

export function focusWithinOutline(offset?: number): RuleSet<object> {
  return css`
  &:focus-within {
    ${outlineStyles(offset ?? 2)};
  }
`
}

export function resetFocusOutline(): RuleSet<object> {
  return css`
  &:focus-visible {
    outline: initial;
    outline-offset: initial;
  }
`
}
